<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 37.7 48.3"
    stroke-width="1.5"
    stroke="currentColor"
    style="enable-background: new 0 0 37.7 48.3"
    xml:space="preserve"
    fill="currentColor"
    :class="{
      [`h-${height} w-${width}`]: true,
    }"
  >
    <path
      class="st0"
      d="M36.4,45.6h-1.6v-5.8c0-3.1-1.3-6-3.6-8.1l-8.4-7.5l8.4-7.5c2.3-2.1,3.6-5,3.6-8.1V2.7h1.6
	c0.8,0,1.4-0.6,1.4-1.4S37.1,0,36.4,0h-35C0.6,0,0,0.6,0,1.4s0.6,1.4,1.4,1.4h1.6v5.8c0,3.1,1.3,6,3.6,8.1l8.4,7.5l-8.4,7.5
	c-2.3,2.1-3.6,5-3.6,8.1v5.8H1.4c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4h35c0.8,0,1.4-0.6,1.4-1.4
	C37.7,46.2,37.1,45.6,36.4,45.6z M8.4,14.6c-1.7-1.5-2.7-3.7-2.7-6V2.7h26.4v5.8c0,2.3-1,4.5-2.7,6L18.9,24L8.4,14.6z M5.7,39.8
	c0-2.3,1-4.5,2.7-6l10.5-9.5l10.5,9.5c1.7,1.5,2.7,3.7,2.7,6v5.8H5.7V39.8z"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
  },
};
</script>
<style scoped>
.st0 {
  fill: #d2001b;
}
</style>
